import { Component, Injector, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { SearchboxV2Service } from '@shopping-angular-components/searchbox-v2';
import { MediaPictureService } from 'projects/common/services/media-picture.service';
import { CommonHeaderComponent, ProductMainTitle } from '../common-header.component';
import { MapService } from "@shopping-angular-components/map";
import { Module } from "../../../model/ModuleModel";
import { MapModuleModel } from "../../map-module/map-module.model";
import { MapModel } from "@shopping-angular-components/map/lib/model/maps.model";
import { UpaService, UpaTarget, UpaTrackingData } from "../../../services/upa.service";


@Component({
  selector: 'header-view-2',
  template: `
        <div class="header-view-2">
            <sbox *ngIf="sboxModule" [sboxModule]="sboxModule" [modulePosition]="position" [forceSearchboxBar]="true" [moduleId]="'HeadingModule'" [uniqueId]="module.unique_id" (click)="showSbox()"></sbox>

            <div *ngIf="screenType.toString() === 'MOBILE'" class="background-mobile"
                [style]="{'background-image': 'url(' + mediaPictureService.getMediaUrl(backgroundModule?.data?.picture, '460x720') + ')'}"></div>

            <div class="main" [style]="{'background-image': 'url(' + mediaPictureService.getMediaUrl(backgroundModule?.data?.picture) + ')'}">
                <div class="header-box"
                    *ngIf="productMainTitleModule?.data as data"
                    [ngClass]="{'-without-price': !data.reference_price.reference_price && screenType.toString() !== 'MOBILE'}">
                    <span class="title-wrapper">
                        <ng-container *ngIf="!titleInNavBar">
                          <tag-text class="pretitle-container" *ngIf="data.pre_title" [data]="data.pre_title"></tag-text>
                          <tag-text class="title-container" *ngIf="data.title" [data]="data.title"></tag-text>
                          <span class="subtitle-wrapper">
                              <tag-text class="subtitle-container" *ngIf="data.sub_title" [data]="data.sub_title"></tag-text>
                              <em *ngIf="data.show_map_link && mapModule?.data" class="map-link eva-3-link" (click)="openMap()">{{'common.view-on-map.DESKTOP' | translate}}</em>
                          </span>
                        </ng-container>

                        <div class="review-container" *ngIf="data.review?.score">
                            <review-score class="eva-3-rating -eva-3-mr-md" [score]="data.review.score" size="-lg"></review-score>
                            <span class="review">
                                <p class="score-name -eva-3-bold">{{data.review.name}}</p>
                                <p *ngIf="screenType.toString() !== 'MOBILE'" class="comments-text -eva-3-tc-gray-2" [innerHTML]="data.review.comments_text"></p>
                                <eva-button *ngIf="data.review.comments_button" class="-eva-3-mt-xsm" [moduleId]="'HeadingModule'"
                                    [moduleIndex]="position" [uniqueId]="module.unique_id" [options]="data.review.comments_button"></eva-button>
                            </span>
                        </div>

                        <eva-button *ngIf="data.reference_price
                            && !data.reference_price.reference_price
                            && data.reference_price.button
                            && screenType.toString() !== 'MOBILE'" class="-eva-3-mt-md"
                            [moduleId]="'HeadingModule'" [moduleIndex]="position" [options]="data.reference_price.button"
                            [uniqueId]="module.unique_id" (clickEvent)="showSbox()"></eva-button>
                    </span>

                    <span *ngIf="data.reference_price?.reference_price" class="reference-price-wrapper" >
                        <span>
                            <p class="reference-text -eva-3-tc-gray-2" [innerHTML]="data.reference_price.reference_text"></p>

                            <p *ngIf="data?.reference_price?.gross_reference_price"
                                class="gross-reference-amount -eva-3-tc-gray-2 strikethrough-text -eva-3-mt-xsm">
                                {{data.reference_price.reference_currency}} {{data.reference_price.gross_reference_price}}
                            </p>

                            <span class="reference-price">
                                <em class="reference-currency">{{data.reference_price.reference_currency}}</em>
                                <em class="reference-amount -eva-3-bold">{{data.reference_price.reference_price}}</em>
                            </span>
                            <p class="referece-date -eva-3-tc-brand-primary-3" [innerHTML]="data.reference_price.reference_date"></p>
                        </span>

                        <dual-promo *ngIf="data.reference_price.promotions_list"
                            [promotionsList]="data.reference_price.promotions_list | reverseArray" position="-bottom-right"></dual-promo>

                        <eva-button *ngIf="data.reference_price.button" class="-eva-3-mt-md"
                            [moduleId]="'HeadingModule'" [moduleIndex]="position" [options]="data.reference_price.button"
                            [uniqueId]="module.unique_id" (clickEvent)="showSbox()"></eva-button>

                        <p *ngIf="data.reference_price.payments && screenType.toString() !== 'MOBILE'" class="payments">{{data.reference_price.payments}}</p>
                    </span>

                    <span *ngIf="!data.reference_price?.reference_price && screenType.toString() === 'MOBILE'" class="reference-price-wrapper" >
                        <span class="-without-price">
                            <p class="reference-text -eva-3-tc-gray-2" [innerHTML]="data.reference_price.reference_text"></p>
                        </span>

                        <eva-button *ngIf="data.reference_price.button"
                            [moduleId]="'HeadingModule'" [moduleIndex]="position" [options]="data.reference_price.button"
                            [uniqueId]="module.unique_id" (clickEvent)="showSbox()"></eva-button>
                    </span>
                </div>
            </div>

            <eva-subnav *ngIf="subnavModule" [viewType]="subnavViewType" [subnav]="subnavModule" [product]="'nymeria-gui'" [flow]="flow" (onClickSubnavItem)="trackUpa($event)"></eva-subnav>
        </div>
    `,
  styleUrls: ['./header-view-2.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class HeaderView2Component extends CommonHeaderComponent implements OnInit {
  @Input() productMainTitleModule?: { data: ProductMainTitle };
  @Input() mapModule?: Module<MapModuleModel>;

  constructor(injector: Injector,
    public mediaPictureService: MediaPictureService,
    private mapService: MapService,
    private upaService: UpaService,
    private searchboxV2Service: SearchboxV2Service) {
    super(injector);
  }

  openMap() {
    if (this.mapModule?.data) {
      const mapData: MapModel = {
        mapType: this.mapModule.data.map_type,
        apiKey: this.mapModule.data.api_key,
        mainMarker: this.mapModule.data.main_marker,
        title: this.mapModule.data.modal_title,
        description: this.mapModule.data.description,
        poiCategories: this.mapModule.data.poi_categories,
        secondaryDescription: this.mapModule.data.secondary_description,
        locale: this.mapModule.data.locale
      }
      this.mapService.openModal(mapData, this.product, this.flow, this.screenType);

      const upaData: UpaTrackingData = {
        moduleId: 'HeadingModule',
        moduleIndex: this.module.position,
        target: UpaTarget.MAP,
        label: 'view-on-map',
        uniqueId: this.module.unique_id
      }
      this.upaService.trackClickTopic(upaData);
    }
  }

  override ngOnInit() {
    super.ngOnInit();
  }

  showSbox() {
    this.searchboxV2Service.showSbox.emit();
    this.searchboxV2Service.highlightSearchbox.emit();
  }

  trackUpa($event) {

    this.module.data.subnav.items.forEach((item, index) => {
      if (item.target.value == $event.value) {
        this.upaService.trackClickTopic({
          label: item.title,
          positionIndex: index,
          moduleId: this.module.id,
          moduleIndex: this.module.position,
          target: UpaTarget.HEADING,
          uniqueId: this.module.unique_id
        })
      }
    });
  }
}
